import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  mode: 'hash', //路由模式，取值为history与hash
  routes: [{
    path: '/',
    redirect: '/login', //重定向到登录
    component: () => import('@/pages/login/login')
  }, {
    path: '/login',
    name: 'LogIn',
    component: () => import('@/pages/login/login'),
  }, {
    path: '/index/guanLiYuan',
    name: 'index',
    redirect: '/index/guanLiYuan/orders', //重定向
    component: () => import('@/pages/guanLiYuan/index/index'),
    children: [{
      path: '/index/guanLiYuan/gongren',
      name: 'gongRen',
      component: () => import('@/pages/guanLiYuan/gongRen/gongRen'),
      meta: {
        requiresAuth: true,
        title: '员工管理',
      }
    }, {
      path: '/index/guanLiYuan/xiaozu',
      name: 'xiaoZu',
      component: () => import('@/pages/guanLiYuan/xiaoZu/xiaoZu'),
      meta: {
        requiresAuth: true,
        title: '生产小组',
      }
    }, {
      path: '/index/guanLiYuan/orders',
      name: 'guanLiYuanOrdersData',
      component: () => import('@/pages/guanLiYuan/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/guanLiYuan/orders/orderDetail',
      name: 'guanLiYuanOrders',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }]
  }, { //经理部分
    path: '/index/jingli',
    name: 'jingliIndex',
    redirect: '/index/jingli/orders', //重定向
    component: () => import('@/pages/jingLi/index/index'),
    children: [{
      path: '/index/jingli/orders',
      name: 'jingliOrdersData',
      component: () => import('@/pages/jingLi/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/jingli/orders/orderDetail',
      name: 'orderDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/jingli/xiaoZu',
      name: 'jingXiaoZu',
      component: () => import('@/pages/guanLiYuan/xiaoZu/xiaoZu'),
      meta: {
        requiresAuth: true,
        title: '生产小组',
      }
    }, {
      path: '/index/jingli/data',
      name: 'jingData',
      component: () => import('@/pages/jingLi/jingData/jingData'),
      meta: {
        requiresAuth: true,
        title: '订单重做统计',
      }
    }],
  }, { //销售部分
    path: '/index/xiaoshou',
    name: 'xiaoshouIndex',
    redirect: '/index/xiaoshou/orders', //重定向
    component: () => import('@/pages/xiaoShou/index/index'),
    children: [{
      path: '/index/xiaoshou/orders',
      name: 'xiaoshouDetail',
      component: () => import('@/pages/xiaoShou/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/xiaoshou/orders/orderUpdate',
      name: 'orderUpdate',
      component: () => import('@/pages/xiaoShou/orderUpdate/orderUpdate'),
      meta: {
        requiresAuth: true,
        title: '订单修改',
      }
    }, {
      path: '/index/xiaoshou/orders/orderDetail',
      name: 'xiaoshouOrderDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/xiaoshou/add/orders',
      name: 'xiaoshouAddOrder',
      component: () => import('@/pages/xiaoShou/orderUpdate/orderUpdate'),
      meta: {
        requiresAuth: true,
        title: '添加订单',
      }
    }]
  }, { //电子开版
    path: '/index/dianzikaiban',
    name: 'dianzikaibanIndex',
    redirect: '/index/dianzikaiban/orders', //重定向
    component: () => import('@/pages/dianziKaiban/index/index'),
    children: [{
      path: '/index/dianzikaiban/orders',
      name: 'dianzikaibanDetail',
      component: () => import('@/pages/dianziKaiban/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/dianzikaiban/kaiban',
      name: 'kaiBan',
      component: () => import('@/pages/dianziKaiban/kaiban/kaiban'),
      meta: {
        requiresAuth: true,
        title: '电子开版',
      }
    }, {
      path: '/index/dianzikaiban/muban',
      name: 'muBan',
      component: () => import('@/pages/dianziKaiban/muban/muban'),
      meta: {
        requiresAuth: true,
        title: '模板库',
      }
    }, {
      path: '/index/dianzikaiban/muban/detail',
      name: 'muBanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '模板详情',
      }
    }, {
      path: '/index/dianzikaiban/orders/orderDetail',
      name: 'dianzikaibanOrdersDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }]
  }, { //激光裁切
    path: '/index/caiqie',
    name: 'caiqieIndex',
    redirect: '/index/caiqie/orders', //重定向
    component: () => import('@/pages/caiqie/index/index'),
    children: [{
      path: '/index/caiqie/orders',
      name: 'caiqieDetail',
      component: () => import('@/pages/caiqie/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/caiqie/orders/orderDetail',
      name: 'caiqieOrdersDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/caiqie/muban/detail',
      name: 'caiqieMubanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }, { //车缝
    path: '/index/chefeng',
    name: 'chefengIndex',
    redirect: '/index/chefeng/orders', //重定向
    component: () => import('@/pages/chefeng/index/index'),
    children: [{
      path: '/index/chefeng/orders',
      name: 'chefengDetail',
      component: () => import('@/pages/chefeng/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/chefeng/orders/orderDetail',
      name: 'chefengOrdersDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/chefeng/muban/detail',
      name: 'chefengMubanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }, { //充棉部分
    path: '/index/chongmian',
    name: 'chongmianIndex',
    redirect: '/index/chongmian/orders', //重定向
    component: () => import('@/pages/chongmian/index/index'),
    children: [{
      path: '/index/chongmian/orders',
      name: 'chongmianDetail',
      component: () => import('@/pages/chongmian/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/chongmian/orders/orderDetail',
      name: 'chongmianOrdersDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/chongmian/muban/detail',
      name: 'chongmianMubanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }, { //造型
    path: '/index/zaoxing',
    name: 'zaoxingIndex',
    redirect: '/index/zaoxing/orders', //重定向
    component: () => import('@/pages/zaoxing/index/index'),
    children: [{
      path: '/index/zaoxing/orders',
      name: 'zaoxingDetail',
      component: () => import('@/pages/zaoxing/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/zaoxing/orders/orderDetail',
      name: 'zaoxingOrdersDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/zaoxing/muban/detail',
      name: 'zaoxingMubanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }, { //喷油
    path: '/index/penyou',
    name: 'penyouIndex',
    redirect: '/index/penyou/orders', //重定向
    component: () => import('@/pages/penyou/index/index'),
    children: [{
      path: '/index/penyou/orders',
      name: 'penyouDetail',
      component: () => import('@/pages/penyou/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/penyou/orders/orderDetail',
      name: 'penyouOrderDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/penyou/muban/detail',
      name: 'penyouMuBanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }, { //质检
    path: '/index/zhijian',
    name: 'zhijianIndex',
    redirect: '/index/zhijian/orders', //重定向
    component: () => import('@/pages/zhijian/index/index'),
    children: [{
      path: '/index/zhijian/orders',
      name: 'zhijianOrders',
      component: () => import('@/pages/zhijian/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, {
      path: '/index/zhijian/orders/orderDetail',
      name: 'zhijianOrderDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    }, {
      path: '/index/zhijian/muban/detail',
      name: 'zhijianMuBanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }, {//客户
    path: '/index/kehu',
    name: 'kehuIndex',
    redirect: '/index/kehu/orders', //重定向
    component: () => import('@/pages/kehu/index/index'),
    children: [{
      path: '/index/kehu/orders',
      name: 'kehuOrders',
      component: () => import('@/pages/kehu/orders/orders'),
      meta: {
        requiresAuth: true,
        title: '数据统计',
      }
    }, 
    {
      path: '/index/kehu/orders/orderDetail',
      name: 'kehuOrderDetail',
      component: () => import('@/pages/jingLi/orderDetail/orderDetail'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
      }
    },
    
    {
      path: '/index/kehu/muban/detail',
      name: 'kehuMuBanDetail',
      component: () => import('@/pages/dianziKaiban/detail/detail'),
      meta: {
        requiresAuth: true,
        title: '开版详情',
      }
    }]
  }]
})


// 全局路由拦截-进入页面前执行
router.beforeEach((to, from, next) => {
  // to: Route : 即将要进入的目标 [路由对象]
  // from: Route : 当前导航正要离开的路由
  // next: Function : 继续执行函数
  if (to.meta.requiresAuth) {
    // if (localStorage.getItem("token")) {
    next();
    // } else {
    //   next({
    //     path: '/login'
    //   })
    // }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js